class LazyloadVideo {
  actionPlay;
  actionStop;
  video;
  currentTime;
  scrollHandler;

  constructor() {
    this.video = document.getElementById('myVideo');
    // this.actionPlay = document.getElementById('ToPlay');
    // this.actionStop = document.getElementById('ToStop');

    if (this.video) {
      this.video.muted = true;
      this.video.volume = 0;
      this.scrollHandler = this.playVideoOnScroll.bind(this);
      window.addEventListener('scroll', this.scrollHandler);
    }

    this.init();
  }

  init() {
    // if (this.video) {
    //   this.video.currentTime = 3;
    // }
    // this.actionPlay.addEventListener('click', () => {
    //   this.playVid();
    // });
    // this.actionStop.addEventListener('click', () => {
    //   this.pauseVid();
    // });
  }

  public playVid() {
    this.video.play();
    this.video.volume = 0.5;
  }

  // public pauseVid() {
  //   this.video.pause();
  // }

  private isElementInViewport(el: HTMLElement): boolean {
    const rect = el.getBoundingClientRect();
    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  private playVideoOnScroll(): void {
    if (this.video && this.isElementInViewport(this.video)) {
      this.playVid();
      window.removeEventListener('scroll', this.scrollHandler);
    }
  }
}

export const lazyloadVideo = new LazyloadVideo();
